module.exports = __webpack_public_path__ + "img/icone-fleet-report.55fa574f.svg";